module.exports = __webpack_public_path__ + "static/img/bbc-faq-error.649dafd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/bbc-faq-error.png
// module id = 1073
// module chunks = 1